import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getBookFlow = asyncThunkWrapper({ 
  model: 'bookFlow', 
  action: 'getBookFlow', 
  func: async () => {
    const attributes = ['id', 'completion_emails', 'failure_emails', 'updated_at'];
    const params = { attributes };
    const response = await axios.get(`/book_flow`, { params });

    return response.data;
  } 
});
export const createBookFlow = asyncThunkWrapper({ 
  model: 'bookFlow', 
  action: 'createBookFlow', 
  func: async (book_flow) => {
    const attributes = ['id', 'completion_emails', 'failure_emails', 'updated_at'];
    const response = await axios.post(`/book_flow`, { book_flow, attributes });

    return response.data;
  } 
});
export const updateBookFlow = asyncThunkWrapper({ 
  model: 'bookFlow', 
  action: 'updateBookFlow', 
  func: async (book_flow) => {
    const response = await axios.patch(`/book_flow`, { book_flow });

    return { status: response.status, book_flow };
  } 
});
export const deleteBookFlow = asyncThunkWrapper({ 
  model: 'bookFlow', 
  action: 'deleteBookFlow', 
  func: async () => {
    const response = await axios.delete(`/book_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveBookFlow = createAction('bookFlow/clearLocalActiveBookFlow');